import { Controller } from "@hotwired/stimulus"

// Recognition & dedication (TMS-1806): each switch shows its own fields (a section names its
// switch in data-toggle). A hidden section's fields, nested ones too, are disabled so they aren't
// posted. An anonymous gift drops "and will be listed as a donor" from the summary's statement.
export default class extends Controller {
  static targets = ["anonymous", "toggle", "section"]

  connect() {
    this.sync()
  }

  sync() {
    this.sectionTargets.forEach((section) => {
      const toggle = this.element.querySelector(`#${section.dataset.toggle}`)
      const shown = Boolean(toggle?.checked) && !section.parentElement.closest("[hidden]")
      section.hidden = !toggle?.checked
      // A switch inside a hidden section posts nothing, which the server reads as off.
      section.querySelectorAll("input, textarea").forEach((field) => { field.disabled = !shown })
    })

    const listing = this.element.querySelector("[data-donation-summary-listing]")
    if (listing && this.hasAnonymousTarget) listing.hidden = this.anonymousTarget.checked
  }
}
